import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import GridImage1 from '../../../images/features/hida/grid-1.png';
import GridImage2 from '../../../images/features/hida/grid-2.png';
import GridImage3 from '../../../images/features/hida/grid-3.png';
import GridImage4 from '../../../images/features/hida/grid-4.png';
import GridImage5 from '../../../images/features/hida/grid-5.png';
import GridImage6 from '../../../images/features/hida/grid-6.png';
import Grid from '@material-ui/core/Grid';
import { makeBackgroundImageStyles } from '../../core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 'bold',
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  box: {
    margin: theme.spacing(2, 'auto'),
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(4, 2),
    '& > *': {
      lineHeight: 1.7,
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 5),
    },
  },
  image: {
    width: '100%',
    paddingTop: `${100 / (12 / 4)}%`,
    [theme.breakpoints.up('sm')]: {
      paddingTop: `${100 / (12 / 3)}%`,
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: `${100 / (12 / 2)}%`,
    },
  },
  grid: {
    margin: theme.spacing(4, 'auto', 0),
  },
}));

const Description = () => {
  const classes = useStyles();

  const gridMemo = React.useMemo(
    () => (
      <Grid container className={classes.grid}>
        {[
          GridImage1,
          GridImage2,
          GridImage3,
          GridImage4,
          GridImage5,
          GridImage6,
        ].map((image) => (
          <Grid
            item
            key={image}
            xs={4}
            sm={3}
            md={2}
            style={makeBackgroundImageStyles(image)}
            className={classes.image}
          />
        ))}
      </Grid>
    ),
    [],
  );

  return (
    <div>
      <Typography color="primary" align="center" className={classes.title}>
        飛騨市のおすすめポイント！
      </Typography>
      <div className={classes.box}>
        <Typography color="textPrimary">
          飛騨市は日本の中心岐阜県の最北端にあります。
        </Typography>
        <Typography color="textPrimary">
          面積の９割が森林で、とても自然豊かで四季が感じられる穏やかな町です。ミネラル豊富な森林が育む水から育つ米や野菜、飛騨牛、そして地酒は最高にうんまいん(おいしい)です。その他にも一度食べたらやみつきになる「とんちゃん」や「漬物ステーキ」など様々な郷土料理もあります。
        </Typography>
        <Typography color="textPrimary">
          さらに伝統文化では、年に１度の奇祭「古川祭」や縁結びの行事「三寺まいり」の他にも地元の方と交流できるローカル感たっぷりの祭りも複数あります。また、１本１本手づくりする「和ろうそく」や「飛騨春慶」や「飛騨家具」は職人の技が光ります。
        </Typography>
        <Typography color="textPrimary">
          地元の人に愛される喫茶店、客足が絶えないお惣菜屋さん、歴史ある町並みに息づく匠の技。おてつたびを通して、美しい飛騨の自然と伝統、面白いひだびとの魅力を感じてください！
        </Typography>
        {gridMemo}
      </div>
    </div>
  );
};

export default Description;
